import React, { Suspense, useEffect } from 'react'
import { Layout } from '@/components/Layout';
import { Route, Routes } from 'react-router-dom';
import styles from './App.module.scss';
import { confluenceResizeCase } from './utils/iframeResizer';
import HomePage from './pages/home';

//@ts-ignore
const PagePathsWithComponents: any = import.meta.glob('./pages/**/*.tsx', {
  eager: true,
});

export const appAllRoutes = Object
  .entries(PagePathsWithComponents)
  .map(
    ([path, componentData]: any) => {
      let [full, url, name] = path.match(/\.\/pages\/((.*)\.tsx)$/)!;

      const nameParts = name.split(/\//g);
      if (nameParts.length) {
        name = nameParts.reverse()[1];
        url = url.replace('/index.tsx', '');
      }

      const component = componentData!.default;

      return {
        name: !name ? 'home' : name,
        path: !name ? '/' : `/${url.toLowerCase()}`,
        component,
      };
    }
  );

export const App: React.FC = () => {

  useEffect(() => {
    confluenceResizeCase()
  }, []);

  return (
    <Suspense fallback={<div>Carregando...</div>}>
      <Layout className={styles.App}>
        <Routes>
          {
            appAllRoutes
              .map(({ path, component: Component }) => {
                return <Route key={path} path={path} element={<Component />} />;
              })
          }
          <Route path={'/sac'} element={<HomePage />} />
          <Route path={'/sac/homologacao'} element={<HomePage />} />
        </Routes>
      </Layout>
    </Suspense>
  );
}
